module.exports = __webpack_public_path__ + "static/img/baoming.46fbdfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/baoming.png
// module id = cRxH
// module chunks = 0